import { createAction, props } from '@ngrx/store';
import { ContentCard } from '../../models';

export const LoadContentCard = createAction('[Content ContentCard] Load Content ContentCard', props<{ id: number }>());
export const LoadContentCardSuccess = createAction('[Content ContentCard] Load Content ContentCard Success', props<{ slider: ContentCard }>());
export const LoadContentCardFail = createAction('[Content ContentCard] Load Content ContentCard Fail', props<{ error: any }>());
